import {CLOSE_SIDEBAR, OPEN_SIDEBAR} from './sidebarTypes';
const initialState = {
   open: false,
   children: null
};

function sidebarReducer(state = initialState, action) {
   switch (action.type) {
      case OPEN_SIDEBAR:
         return {...state, open: true, ...action.payload};
      case CLOSE_SIDEBAR:
         return initialState;
      default:
         return state;
   }
}

export default sidebarReducer;
